// extracted by mini-css-extract-plugin
export default {"status":"index_status__r58nw"};